import { z } from "zod";

export const resendConnectionSchema = z.object({
  name: z.string().min(1, "Nama wajib diisi"),
  fromAddress: z.string().email("Alamat email tidak valid"),
  apiKey: z.string().optional(),
});

export type ResendConnectionFormValues = z.infer<typeof resendConnectionSchema>;

export const defaultResendConnectionValues: ResendConnectionFormValues = {
  name: "",
  fromAddress: "",
  apiKey: "",
};
